<template>
    <div>
        <b-overlay :show="!dataLoaded">
            <b-card title="Segments">

                <delete-items-button v-if="$hasPermission($permissions.RemoveSegments)" :selection="selection" @deleted="loadData" @reset=" selection.selected_item_ids = []"/>


                <b-button v-if="$hasPermission($permissions.AddSegments)" variant="primary" @click="addSegmentModalActive = true">
                    <feather-icon
                        icon="PlusIcon"
                        class="mr-50"
                    />
                    <span class="align-middle">Add</span>
                </b-button>

                <basic-table ref="basicTable"  :columns="columns" :data="segments" v-slot="props" @update-selection="updateSelection" @filter-update="filterUpdate">
                    <div v-if="props.column.displayType === 3 && $hasPermission($permissions.RemoveSegments)" class="d-flex justify-content-center">
                        <b-form-checkbox  v-model="selection.selected_item_ids" :value="props.row.id"></b-form-checkbox>
                    </div>
                    <div v-else-if="props.column.displayType === 1" class="d-flex justify-content-center">
                        <b-button v-if="$hasPermission($permissions.EditSegments)" variant="warning" @click="openSegmentEdit(props.row)" class="mr-1">
                            <feather-icon icon="EditIcon"/>
                        </b-button>
                        <b-button v-if="$hasPermission($permissions.RemoveSegments)" variant="danger" @click="removeSegment(props.row.id)" class="mr-1">
                            <feather-icon icon="Trash2Icon"/>
                        </b-button>
                    </div>
                    <div v-else-if="props.column.displayType === 2" class="d-flex justify-content-center">
                        <div class="rounded-sm mr-1" :style="{width: '60px', height: '25px', backgroundColor: props.formattedRow[props.column.field] }"></div>
                        {{ props.formattedRow[props.column.field] }}
                    </div>
                    <span v-else class="d-flex justify-content-center">
                        {{ props.formattedRow[props.column.field] }}
                    </span>

                </basic-table>
            </b-card>

            <b-modal title="Add outlet segment" v-model="addSegmentModalActive" no-close-on-backdrop>
                <template #default>
                    <b-form-group>
                        <label>Name</label>
                        <b-form-input v-model="addObject.name"/>
                    </b-form-group>

                    <ColorPicker v-model="addObject.color"/>
                </template>

                <template #modal-footer>

                    <b-button variant="danger" @click="addSegmentModalActive = false">
                        <feather-icon
                            icon="XIcon"
                            class="mr-50"
                        />
                        <span class="align-middle">Close</span>
                    </b-button>

                    <b-button variant="primary" @click="addSegment">
                        <feather-icon
                            icon="PlusIcon"
                            class="mr-50"
                        />
                        <span class="align-middle">Add</span>
                    </b-button>
                </template>
            </b-modal>

            <b-modal title="Edit outlet segment" v-model="editSegmentModalActive" no-close-on-backdrop>
                <template #default>
                    <b-form-group>
                        <label>Name</label>
                        <b-form-input v-model="editObject.name"/>
                    </b-form-group>

                    <ColorPicker v-model="editObject.color"/>
                </template>

                <template #modal-footer>

                    <b-button variant="danger" @click="editSegmentModalActive = false">
                        <feather-icon
                            icon="XIcon"
                            class="mr-50"
                        />
                        <span class="align-middle">Close</span>
                    </b-button>

                    <b-button variant="warning" @click="saveSegment">
                        <feather-icon
                            icon="SaveIcon"
                            class="mr-50"
                        />
                        <span class="align-middle">Save</span>
                    </b-button>
                </template>
            </b-modal>
        </b-overlay>
    </div>
</template>
<script>

    import {BButton, BCard, BOverlay, BFormGroup, BFormInput, BFormCheckbox} from 'bootstrap-vue'
    import BasicTable from '@/views/components/BasicTable'
    import ColorPicker from '@/views/components/ColorPicker'
    import DeleteItemsButton from '@/views/components/DeleteItemsButton.vue'

    export default {
        components: {
            DeleteItemsButton,
            ColorPicker,
            BCard,
            BOverlay,
            BasicTable,
            BFormGroup,
            BFormInput,
            BButton,
            BFormCheckbox
        },
        data() {
            return {
                dataLoaded: false,
                segments: [],
                selection:{
                    selected_item_ids:[],
                    collection_name:''
                },
                columns: [
                    {
                        label: 'Select',
                        displayType: 3,
                        field: 'select',
                        sortable: false,
                        filterOptions: {
                            enabled: false
                        }
                    },
                    {
                        label: 'Name',
                        displayType: 0,
                        field: 'name',
                        filterOptions: {
                            enabled: true,
                            placeholder: 'Search'
                        }
                    },
                    {
                        label: 'Color',
                        displayType: 2,
                        field: 'color',
                        filterOptions: {
                            enabled: true,
                            placeholder: 'Search'
                        }
                    },
                    {
                        label: 'Actions',
                        displayType: 1,
                        field: 'actions',
                        sortable: false,
                        filterOptions: {
                            enabled: false
                        }
                    }
                ],

                addObject: {name: '', color: '#000000'},
                addSegmentModalActive: false,

                editObject: {name: '', color: '#000000'},
                editSegmentModalActive: false
            }
        },
        methods: {
            openSegmentEdit(segment) {
                this.editObject = JSON.parse(JSON.stringify(segment))
                this.editSegmentModalActive = true
            },
            loadData() {
                this.$refs.basicTable.$refs.table.reset()
                this.dataLoaded = false
                const thisIns = this
                const loadPromise = this.$http.get('/api/management/v1/outlet_segment')
                loadPromise.then(function(response) {
                    thisIns.segments = response.data
                }).catch(function(error) {
                    thisIns.$printError((error.response) ? error.response.data : error)
                })

                Promise.all([loadPromise]).finally(function() {
                    thisIns.dataLoaded = true
                })
            },
            addSegment() {
                const thisIns = this
                const addPromise = this.$http.post('/api/management/v1/outlet_segment', this.addObject)
                addPromise.then(function() {
                    thisIns.addSegmentModalActive = false
                    thisIns.$printSuccess('Outlet segment added')
                    thisIns.addObject = {name: ''}
                    thisIns.loadData()
                }).catch(function(error) {
                    thisIns.$printError((error.response) ? error.response.data : error)
                })
            },
            saveSegment() {
                const thisIns = this
                const savePromise = this.$http.put(`/api/management/v1/outlet_segment/${  this.editObject.id}`, this.editObject)
                savePromise.then(function() {
                    thisIns.editSegmentModalActive = false
                    thisIns.$printSuccess('Outlet segment saved')
                    thisIns.loadData()
                }).catch(function(error) {
                    thisIns.$printError((error.response) ? error.response.data : error)
                })
            },
            async removeSegment(id) {

                try {

                    const confirmDelete = await this.$confirmDialog('Do you want to delete this segment?')
                    
                    if (!confirmDelete) return
                    await this.$http.delete(`/api/management/v1/outlet_segment/${  id}`)
                    this.$printSuccess('Outlet segment removed')
                } catch (error) {
                    this.$printError((error.response) ? error.response.data : error)
                } finally {
                    this.loadData()
                }
            },
            updateSelection(e) {
                if (this.$refs.basicTable.$refs.table.paginated[0] && this.$refs.basicTable.$refs.table.processedRows[0] && e) {
                    let arr = []
                    const pagResults = this.$refs.basicTable.$refs.table.paginated[0].children
                    const filterResults = this.$refs.basicTable.$refs.table.processedRows[0].children

                    arr = pagResults.filter(element => filterResults.includes(element))
                    arr.forEach((item) => {
                        const el =  this.selection.selected_item_ids.includes(item.id)
                        if (!el)   this.selection.selected_item_ids.push(item.id)
                    })
                } else {
                    this.selection.selected_item_ids = []
                }
            },
            filterUpdate(e) {
                e.forEach((item) => {
                    const el =  this.selection.selected_item_ids.includes(item.id)
                    if (el)   this.selection.selected_item_ids.splice(item.id)
                })
                this.$store.dispatch('app/updateSelectAll', false)
            }
        },
        mounted() {
            this.selection.collection_name = 'outlet_segment'

            this.loadData()
        }
    }
</script>